import { useCallback } from 'react'
import { useNavigate } from 'react-router'

import { InvoiceDocumentType } from '@features/invoices/enums/invoiceDocumentType'
import { getInvoiceDocumentRouteBase } from '@features/invoices/utils/getInvoiceDocumentRouteBase'
import { useUserOrganization } from '@modules-deprecated/app/organization'

import { getOrganizationViewUrl } from '../../../utils/routing/getOrganizationViewUrl'
import { reactRoute } from '../../../utils/routing/reactRoute'

export const useDuplicateSalesDocument = () => {
  const { organization } = useUserOrganization()
  const navigate = useNavigate()

  const duplicateSalesDocument = useCallback(
    (documentId: string, documentType: InvoiceDocumentType) => {
      const invoiceDocumentRouteBase = getInvoiceDocumentRouteBase(documentType)

      navigate(
        `${getOrganizationViewUrl(
          organization?.url,
          reactRoute.organization.invoices.getDuplicateDocumentRoute(invoiceDocumentRouteBase, String(documentId)),
        )}`,
      )
    },
    [navigate, organization?.url],
  )

  return { duplicateSalesDocument }
}
